var map = {
	"./admin_user_channel": 1360,
	"./admin_user_channel.js": 1360,
	"./chat_channel": 1337,
	"./chat_channel.js": 1337,
	"javascript/legacy/channels/admin_user_channel": 1360,
	"javascript/legacy/channels/admin_user_channel.js": 1360,
	"javascript/legacy/channels/chat_channel": 1337,
	"javascript/legacy/channels/chat_channel.js": 1337
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3276;